import React, {useState} from 'react';
import {observer} from 'mobx-react';
import {ActionLink, QuickTip} from 'components';
import {FormattedMessage} from 'react-intl';
import {api, auth, endpoints} from 'shared/core';
import {calendarDate} from 'shared/tools';


const MissingApproversWarning = observer(() => {
  if (!auth.featureEnabled(':time_off_approvers')) {
    return null;
  }

  const [missingApprovers, setMissingApprovers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  React.useEffect(() => {
    const fetchData = async () => {
      const response = await api.get(endpoints.TIME_OFF.MISSING_APPROVERS);
      setMissingApprovers(response.data);
      setIsLoading(false);
    };
    fetchData();
  }, []);

  if (isLoading || missingApprovers.length === 0) {
    return null;
  }

  const paragraphs = [
    <FormattedMessage
      id='time_off.missing_approvers.WARNING_MESSAGE_1'
    />,
    <FormattedMessage
      id='time_off.missing_approvers.WARNING_MESSAGE_2'
      values={{date: <b>{calendarDate('January 1, 2026')}</b>}}
    />
  ];

  if (isExpanded) {
    paragraphs.push(
      <ul className='mt2 ml3'>
        {missingApprovers.map(({policy, types}, index) => (
          <li key={index}>
            {policy}{' - '}{types.join(', ')}
          </li>
        ))}
      </ul>
    );
  }

  paragraphs.push(
    <ActionLink onClick={toggleExpanded}>
      {isExpanded ?
        <FormattedMessage id='time_off.missing_approvers.Hide policies'/>
        : <FormattedMessage id='time_off.missing_approvers.List policies'/>
      }
    </ActionLink>
  );

  return (
    <div className='mb2'>
      <QuickTip
        trait='error'
        paragraphs={paragraphs}
        header={<FormattedMessage id='time_off.missing_approvers.Time off policies require your attention'/>}
      />
    </div>
  );
});


export default MissingApproversWarning;
